import { render, staticRenderFns } from "./TagPool.vue?vue&type=template&id=2616f8a7"
import script from "./TagPool.vue?vue&type=script&lang=js"
export * from "./TagPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports